import React, { useEffect, useState } from 'react';
import Input from 'components/common/Input';
import { Card, Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

const ArticleQuantities = () => {
 const {
  watch,
  setValue,
  formState: { errors }
 } = useFormContext();

 const selts = watch('quantities') ?? [];
 const selects = () => selts.map(e => ({ value: e, label: e })) ?? [];

 const [select, setSelect] = useState({
  quantities: selects(),
  options: [{ value: '10', label: '10' }, { value: '20', label: '30' }, { value: '100', label: '100' }, ...selects()]
 });

 const createOption = inputValue => {
  setSelect(prev => ({
   ...prev,
   options: [...prev.options, { label: inputValue, value: inputValue }],
   quantities: [...prev.quantities, { label: inputValue, value: inputValue }]
  }));
 };

 useEffect(() => {
  setSelect(prev => ({ ...prev, quantities: selects() }));
 }, [selts]);

 return (
  <Card className="mb-3">
   <Card.Header as="h6" className="bg-body-tertiary">
    Cantidades
   </Card.Header>
   <Card.Body>
    <Row className="gx-2 gy-3">
     <Input
      type="selectMulti"
      name="quantities"
      errors={errors}
      placeholder="Seleccione..."
      options={select?.options}
      label="Añadir cantidades:"
      formGroupProps={{ as: Col, md: 12 }}
      formControlProps={{
       isClearable: true,
       isMulti: true,
       closeMenuOnSelect: true,
       onChange: newValue =>
        setValue(
         'quantities',
         newValue.map(e => e.value)
        ), //setSelect(prev => ({ ...prev, quantities: newValue })),
       onCreateOption: createOption,
       value: select?.quantities
      }}
     />
    </Row>
   </Card.Body>
  </Card>
 );
};

export default ArticleQuantities;
